module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/m60_small.ead28ac0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/m60_small.png
// module id = 1028
// module chunks = 16